export default __webpack_public_path__ + "static/media/image4.00c3ab25.webp";